import React, { useEffect, useState } from 'react'
import {Check, ShieldCheck, CreditCard, Lock} from 'lucide-react'

function Offer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0')
  const seconds = (timeLeft % 60).toString().padStart(2, '0')

  const items = [
    'Mais de 400 receitas exclusivas',
    'Método Massa Perfeita™ completo',
    'Atualizações mensais gratuitas',
    'Aplicativo completo',
    'E-book Café da Manhã Perfeito',
    'E-book Doces Sem Culpa',
    'E-book Bases Culinárias Essenciais',
    'Acesso pelo celular, tablet e computador',
  ]

  return (
    <section id="oferta" className="bg-white py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10 animate-fade-up">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#49352B] text-white rounded-full text-sm font-semibold">
            ⏳ Oferta expira em {minutes}:{seconds}
          </div>
        </div>

        <div className="relative max-w-3xl mx-auto animate-fade-up">
          <div className="absolute -inset-6 bg-[#D9891B]/15 rounded-[40px] blur-3xl -z-10" />
          <div className="relative bg-[#FCFAF5] rounded-[24px] border-2 border-[#D9891B]/30 shadow-2xl p-10 md:p-16 text-center">
            <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold mb-3">
              Hoje você volta a sentir o prazer de comer tudo aquilo que imaginou que nunca mais poderia
            </h2>
            <p className="text-[#49352B]/60 font-medium mb-10">Acesso completo ao Método Massa Perfeita™ por apenas R$ 27,90 — menos do que o preço de uma única pizza.</p>

            <p className="text-[#49352B]/50 text-sm uppercase tracking-wide font-semibold mb-4">Tudo o que você recebe hoje:</p>
            <div className="space-y-3 mb-10 text-left max-w-md mx-auto">
              {items.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-[#5E774B] flex-shrink-0 mt-0.5" />
                  <span className="text-[#49352B]/80">{item}</span>
                </div>
              ))}
            </div>

            <div className="mb-10">
              <p className="text-lg text-[#49352B]/50">Valor normal do acesso completo</p>
              <p className="text-lg text-[#49352B]/50 line-through">R$ 97,00</p>
              <p className="text-[#49352B]/70 font-semibold text-lg mt-3">Oferta Especial de Lançamento</p>
              <p className="text-6xl md:text-8xl font-display font-bold text-[#D9891B] my-3 leading-none">R$ 27,90</p>
              <p className="text-[#49352B]/60 font-medium">Pagamento único • Acesso imediato</p>
            </div>

            <p className="text-[#49352B] font-display font-bold text-lg mb-4">Sua compra é 100% segura</p>

            <a
              href="https://app.klumify.com.br/produto/ad3f29ec-d4d7-425b-b4c2-35d9324a6c0b"
              className="w-full h-[76px] flex items-center justify-center bg-[#D9891B] hover:bg-[#c17a15] text-white text-xl font-semibold rounded-[18px] transition-all duration-300 transform hover:scale-[1.03] shadow-[0_24px_48px_-8px_rgba(217,137,27,0.55)] hover:shadow-[0_28px_56px_-8px_rgba(217,137,27,0.7)]"
            >
              QUERO VOLTAR A COMER PÃO DE VERDADE
            </a>

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-5 text-[#49352B] text-sm font-semibold">
              <span>✓ Acesso imediato</span>
              <span>✓ Atualizações gratuitas</span>
              <span>✓ Garantia incondicional de 7 dias</span>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-6 text-[#49352B]/70 text-sm font-medium">
              <span className="flex items-center gap-1.5">🔒 Compra 100% segura</span>
              <span className="flex items-center gap-1.5">💳 Parcelamento disponível</span>
              <span className="flex items-center gap-1.5">⚡ Liberação imediata</span>
            </div>

            <div className="flex items-center justify-center gap-6 mt-6 pt-6 border-t border-[#EBD9C3] text-[#49352B]/50 text-xs">
              <span className="flex items-center gap-1.5"><Lock className="w-4 h-4" /> Compra segura</span>
              <span className="flex items-center gap-1.5"><CreditCard className="w-4 h-4" /> Cartão e Pix</span>
              <span className="flex items-center gap-1.5"><ShieldCheck className="w-4 h-4" /> Garantia 7 dias</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Offer
